export default __webpack_public_path__ + "static/media/mobile-asset2.1c34841b.png";